<template>
  <ul :class="className ?? 'relative -top-2.5'">
    <li v-for="msg in messages" class="relative text-[1rem]" :class="(variant === 'ab' ? 'text-ab-red-500' : 'text-red-400')">
      {{ msg }}
    </li>
  </ul>
</template>
<script>
export default {
  name: 'input-messages',
  props: {
    messages: Array,
    variant: String,
    className: String
  }
}
</script>
